import { observer } from 'mobx-react';
import { Grid, Box, Menu, MenuItem, ListItemText, ListItemIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useState, useRef } from 'react';
import { Toolbar, Button, ConfirmDialog } from '@roc/ui';
import { InternalValuationStore } from "../stores/internalValuationStore"
import { SelectReviewerDropdown } from './selectReviewerDropdown';
import { ArrowDropDown, ControlPoint } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  content: {
    fontWeight: 'bold',
    fontSize: '15px'
  },
  label: {
    fontSize: '13px',
  },
  labelBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  dataPoint: {
    marginTop: '5px',
    textAlign: 'center',
  },
  containerBox: {
    display: 'flex',
  },
}));

interface InternalValuationDashboardToolbarProps {
  internalValuationStore: InternalValuationStore
}

export const InternalValuationDashboardToolbar = observer(({ internalValuationStore }: InternalValuationDashboardToolbarProps) => {
  const [showAssignDialog, setShowAssignDialog] = useState(false);
  const [showBulkActionsMenu, setShowBulkActionsMenu] = useState(false);
  const classes = useStyles();
  const anchorRef = useRef(null);
  const [selectedReviewer, setSelectedReviewer] = useState<number | ''>('');

  const handleClose = () => setShowAssignDialog(false);

  const handleConfirm = () => {
    if (internalValuationStore.selectedRecords.length > 0 && selectedReviewer) {
      setShowAssignDialog(false);
      internalValuationStore.bulkUpdateValuationReviewer(selectedReviewer)
    } else {
      internalValuationStore.globalStore.notificationStore.showInfoNotification({
        message: "Please select a loan first"
      });
    }
  }

  const closeMenu = () => {
    setShowBulkActionsMenu(false);
  };

  const dialogContent = (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12}>
        <SelectReviewerDropdown
          value={selectedReviewer}
          options={internalValuationStore.valuationReviewers}
          onChange={setSelectedReviewer}
        />
      </Grid>
    </Grid>
  );

  return (
    <Grid container>
      <Grid item xs={12}>
        <Toolbar>
          <Box className={classes.containerBox}>
            <Box style={{ textAlign: 'center' }}>
              <div ref={anchorRef} style={{ display: 'inline-block' }}>
                <Button
                  id="basic-button"
                  testId='showBulkAssignDiaglog'
                  color='primary'
                  variant='contained'
                  disabled={internalValuationStore.selectedRecords.length === 0}
                  onClick={() => setShowBulkActionsMenu(true)}
                  size="small"
                >
                  Bulk Actions <ArrowDropDown style={{ marginRight: '-6px' }} />
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorRef.current}
                  open={showBulkActionsMenu}
                  onClose={closeMenu}
                  keepMounted={true}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => {
                      setShowAssignDialog(true);
                      closeMenu();
                    }}
                  >
                    <ListItemIcon>
                      <ControlPoint fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Assign Reviewer</ListItemText>
                  </MenuItem>
                </Menu>
              </div>

            </Box>
          </Box>
        </Toolbar>
      </Grid>
      <ConfirmDialog
        open={showAssignDialog}
        title='Assign selected loans to'
        confirmButtonText='Assign'
        cancelButtonText='Close'
        handleClose={handleClose}
        handleCancel={handleClose}
        handleConfirm={handleConfirm}
        body={dialogContent}
      />
    </Grid>
  );
});
